import {
  HeadlineOne,
  SectionWrapper,
} from 'components/atoms/SectionWrapper.style';
import React from 'react';
import FormImages from 'components/organisms/formComponents/formImages/FormImages';
import ContactIconsWrapper from 'components/organisms/formComponents/contactIconsWrapper/ContactIconsWrapper';
import GoogleApiWrapper from 'components/organisms/formComponents/maps/Maps';
import styled from 'styled-components';
import Header from 'components/organisms/header/Header';
import EleHeader from 'components/organisms/header/EleHeader';

const EditHeadline = styled(HeadlineOne)`
  margin-top: 100px;
`;

const MapsWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

const FormCenter = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const EleContact = () => (
  <>
    {/* <FormImages /> */}
    <EleHeader />
    <SectionWrapper>
      <FormCenter>
        <EditHeadline>ZAPRASZAMY DO KONTAKTU</EditHeadline>
        <ContactIconsWrapper />
      </FormCenter>
      <MapsWrapper>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4637.859155975473!2d18.458799!3d54.464179!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46fda1a48402e0db%3A0x70efc1a7d59516af!2sRdestowa%2051%2C%20Gdynia!5e0!3m2!1spl!2spl!4v1657397106979!5m2!1spl!2spl"
          width="80%"
          height="400px"
          border="white 1px solid"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </MapsWrapper>
    </SectionWrapper>
  </>
);

export default EleContact;
